<div class="w-full h-full overflow-auto hide-scroll flex content-start flex-wrap" infiniteScroll
  [infiniteScrollDistance]="1" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="loadMore()">
  <article class="w-full flex flex-wrap">
    <app-header class="sticky top-0 z-50 bg-white dark:bg-gray-900 shadow-sm" [_Config]="headerConfig"></app-header>

    <div class="w-full flex flex-wrap mt-3">
      <ng-container *ngIf="!loading; else skeletonTemplate">
        <ng-container *ngFor="let booklist of booklists">
          <div class="w-full pb-3 px-4 mb-3 flex flex-wrap border-b border-gray-100 dark:border-gray-600">
            <!-- ? Actor -->
            <app-user-activity-info class="w-full" [User]="booklist | getUserData: false" [inside]="false"
              [displayDate]="true"> </app-user-activity-info>

            <!-- ? Booklist -->
            <app-booklist-item class="mt-12 w-full" [Booklist]="booklist"></app-booklist-item>

            <!-- ? Footer -->
            <app-activity-footer-pluse class="mt-3 w-full" [Activity]="booklist | footerItem: false"
              [activeCommentLink]="true" (usersClicked)="openUsersDialog($event)" (likeClicked)="likeItem($event)"
              (bookmarkClicked)="bookmarkItem($event)">
            </app-activity-footer-pluse>
          </div>
        </ng-container>

        <div class="w-full" [ngClass]="{ hidden: !loadingMore }">
          <div class="w-full my-3 flex justify-center items-center">
            <div class="rounded-full flex justify-center items-center">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </article>

  <!-- <article class="left-article">
        <app-home-currently-reading></app-home-currently-reading>
    </article> -->
</div>

<ng-template #skeletonTemplate>
  <div class="w-full flex flex-wrap mt-3 pb-3 border-b border-gray-100 dark:border-gray-600"
    *ngFor="let item of [1, 2, 3]">
    <!-- ? Actor -->
    <div class="w-full flex flex-wrap items-center">
      <ngx-skeleton-loader [appearance]="'circle'" [theme]="{ height: '48px', width: '48px' }"></ngx-skeleton-loader>
      <div class="col flex flex-wrap">
        <ngx-skeleton-loader class="flex mr-1" [theme]="{ height: '16px', width: '150px' }"> </ngx-skeleton-loader>
        <ngx-skeleton-loader class="w-full flex mr-1 mt-2" [theme]="{ height: '12px', width: '200px' }">
        </ngx-skeleton-loader>
      </div>
    </div>

    <ngx-skeleton-loader class="w-full my-3" [theme]="{ height: '120px' }"> </ngx-skeleton-loader>
  </div>
</ng-template>